import React, { useEffect, useState } from "react";
import "./SuccessPage.css";
import successimage from "./SuccessImage.png";
import { db } from "../../../firebase";
import { setDoc } from "firebase/firestore";
import { collection, doc } from "firebase/firestore";
import { getAuth } from "firebase/auth";

function SuccessPage(props) {

  const currentuser = getAuth().currentUser;

  useEffect(async () => {
    // setting payment
    try {
      const customerRef = collection(db, "FreeTrialUsers");
      await setDoc(doc(customerRef, currentuser.uid), {
        freetrial: true,
      });
    } catch (error) {
      console.log(error);
    }
  }, []);

  return (
    <div className="success-page-container">
      <img src={successimage} alt="success" />
      <h1 className="payment-success">Payment Successful</h1>
      <a href={`/blog/${props.match.params.id}`}>Go Back</a>
    </div>
  );
}

export default SuccessPage;
